// extracted by mini-css-extract-plugin
module.exports = {"email":"Email_email__9fcEX"};